import '../node_modules/jquery/dist/jquery.js';
import '../node_modules/jwt-decode/build/jwt-decode.min.js';
import * as ko from 'knockout';
import Navigo = require("navigo");
import './components/dashboard/dashboard';
import './components/login/login';
import './components/appointment/appointment';
import './components/document/header'
import './components/deadline/overview';
import './components/deadline/deadline';
import './components/resubmission/overview';
import './components/resubmission/resubmission';
import './components/case/case';
import './components/case/fastcase';
import './components/case/overview';
import './components/case/caseentries';
import './components/case/caseentryoverview';
import './components/extended/extendedForm';
import './components/extended/extendedTabs';
import './components/extended/extendedMain';
import './components/tag/overview';
import './components/tag/tag';
import './components/view/overview';
import './components/view/view';
import './components/textTree/generation';
import './components/address/address';
import './components/address/overview';
import './components/debug/debug';
import './components/note/note';
import './components/fee/calculator';
import './components/dictation/record';
import './components/zpe/mail';
import './components/zpe/compose';
import './components/zpe/inbox';
import './components/zpe/inboxoverview';
import './components/workflow/zpe';
import './components/tree/tree';
import './components/tree/overview';
import './components/strategy/overview';
import './components/strategy/strategy';
import './components/taxonomie/taxonomie';
import './components/taxonomie/overview';
import './components/unit/addunit';
import { RNSAPI, Routing } from './api';
import { User } from './UserData';
import { Utils } from './utils';

export class MainViewModel {
    public currentRoute = ko.observable("login-view")
    public currentParams = ko.observable(undefined)
    public showLogout = ko.observable(false);

    public logout() {
        MainViewModel.RoutingTable.showLoginView();
        vm.showLogout(false);
    }

    public router = new Navigo(null, true);
    public static paused = false;

    constructor() {
        this.router.on({
            '/': () => this.router.navigate('/dashboard'),
            '/login': () => this.currentRoute("login-view"),
            '/cases': () => this.currentRoute("caseoverview-view"),
            '/extended-main/:caseId': (params) => {
                this.currentRoute("extended-main-view");
                this.currentParams(params);
            },
            '/fastcase': () => this.currentRoute("fastcase-view"),
            '/case': (params) => {
                this.currentRoute("case-view");
                this.currentParams(undefined);
            },
            '/case/:caseId': (params) => {
                this.currentRoute("case-view");
                this.currentParams(params);
            },
            '/unit/add': () => { this.currentRoute("addunit-view") },
            '/caseentry/:caseId': (params) => {
                this.currentRoute("caseentry-view");
                this.currentParams(params);
            },
            '/caseentry/:caseId/:eCaseRecordId': (params) => {
                this.currentRoute("caseentry-view");
                this.currentParams(params);
            },
            '/caseentries': (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams(params);
            },
            '/caseentries/:caseId': (params) => {
                this.currentRoute("caseentries-view");
                this.currentParams(params);
            },
            '/caseentries/:caseId/:eCaseRecordId': (params) => {
                this.currentRoute("caseentries-view");
                this.currentParams(params);
            },
            '/tags': (params) => this.currentRoute("tagoverview-view"),
            '/tag/:name': (params) => {
                this.currentRoute("tag-view");
                this.currentParams(params);
            },
            '/tag': (params) => {
                this.currentRoute("tag-view");
                this.currentParams(undefined);
            },
            '/views': (params) => this.currentRoute("viewoverview-view"),
            '/view/:name': (params) => {
                this.currentRoute("view-view");
                this.currentParams(params);
            },
            '/view': (params) => {
                this.currentRoute("view-view");
                this.currentParams(undefined);
            },
            '/addresses': () => this.currentRoute("addressoverview-view"),
            '/address': (params) => {
                this.currentRoute("address-view");
                this.currentParams(undefined);
            },
            '/address/:type/:keyword': (params) => {
                this.currentRoute("address-view");
                this.currentParams(params);
            },
            '/appointment': (params, query) => {
                this.currentRoute("appointment-view");
                this.currentParams({ startdate: Utils.getParameterByName("startdate", window.location.href) });
            },
            '/appointment/:id': (params) => {
                this.currentRoute("appointment-view");
                this.currentParams(params);
            },
            '/deadline': (params) => {
                this.currentRoute("deadline-view");
                this.currentParams(undefined);
            },
            '/resubmissions': (params) => {
                this.currentRoute("resubmissionoverview-view");
                this.currentParams(undefined);
            },
            '/resubmission': (params, query) => {
                this.currentRoute("resubmission-view");
                this.currentParams({ caseId: Utils.getParameterByName("caseId", window.location.href) });
            },
            '/resubmission/:id': (params) => {
                this.currentRoute("resubmission-view");
                this.currentParams(params);
            },
            '/deadlines': () => {
                this.currentRoute("deadlineoverview-view")
                this.currentParams(undefined);
            },
            '/dashboard': () => {
                this.currentRoute("dashboard-view")
                this.currentParams({ view: "todos" });
            },
            '/dashboard/:view': (params) => {
                if (!MainViewModel.paused) {
                    this.currentRoute("dashboard-view");
                    this.currentParams(params);
                }
                MainViewModel.paused = false;
            },
            '/generation/:caseId': async (params) => {
                this.currentRoute("generation-view");
                this.currentParams({ caseId: params.caseId });
            },
            '/generation': async (params) => {
                this.currentRoute("generation-view");
                this.currentParams();
            },
            '/calculator': async (params) => {
                this.currentRoute("calculator-view");
            },
            '/note': async () => {
                this.currentRoute("note-view");
            },
            '/note/:id': async (params) => {
                this.currentRoute("note-view");
                this.currentParams(params);
            },
            '/dictation': async () => {
                this.currentRoute("record-view");
            },
            '/dictation/:id': async (params) => {
                this.currentRoute("record-view");
                this.currentParams(params);
            },
            '/compose': async (params) => {
                this.currentRoute("compose-view");
                this.currentParams(undefined);
            },
            '/compose/:caseId': async (params) => {
                this.currentRoute("compose-view");
                this.currentParams(params);
            },
            '/compose/:caseId/:eCaseRecordId': async (params) => {
                this.currentRoute("compose-view");
                this.currentParams(params);
            },
            '/mail/:accountId/:mailId': async (params) => {
                this.currentRoute("mail-view");
                this.currentParams(params);
            },
            '/inbox': async (params) => this.currentRoute("inbox-view"),
            '/inbox/:id': async (params) => {
                this.currentRoute("inbox-view");
                this.currentParams(params);
            },
            '/inboxes': async (params) => {
                this.currentRoute("inboxoverview-view");
            },
            '/zpe': async (params) => {
                this.currentRoute("zpe-view");
            },
            '/wfk/PE': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "PE" });
            },
            '/wfk/ZU': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "ZU" });
            },
            '/wfk/PA': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "PA" });
            },
            '/wfk/RA': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "RA" });
            },
            '/wfk/B': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "B" });
            },
            '/wfk/E': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "E" });
            },
            '/wfk/V': async (params) => {
                this.currentRoute("caseentryoverview-view");
                this.currentParams({ workflow: "V" });
            },
            '/tree/:type/:id': async (params) => {
                this.currentRoute("tree-view");
                this.currentParams(params);
            },
            '/tree': async (params) => {
                this.currentRoute("tree-view");
                this.currentParams(undefined);
            },
            '/trees': async (params) => {
                this.currentRoute("treeoverview-view");
                this.currentParams(undefined);
            },
            '/strategy': async (params) => {
                this.currentRoute("strategy-view");
                this.currentParams(undefined);
            },
            '/strategies': async (params) => {
                this.currentRoute("strategyoverview-view");
                this.currentParams(undefined);
            },
            '/taxonomie': async (params) => {
                this.currentRoute("taxonomie-view");
                this.currentParams(undefined);
            },
            '/taxonomie/:id': async (params) => {
                this.currentRoute("taxonomie-view");
                this.currentParams(params);
            },
            '/taxonomies': async (params) => {
                this.currentRoute("taxonomieoverview-view");
                this.currentParams(undefined);
            },
            '/letterhead/upload': async(params) =>{
                this.currentRoute("letterhead-upload-view");
                this.currentParams(undefined);
            },
        }).resolve();

        let cookie = Utils.readCookie("jwt");
        if (cookie === null) {
            MainViewModel.RoutingTable.showLoginView();
        } else {
            RNSAPI.Token = cookie;
            let decoded = (window as any).jwt_decode(RNSAPI.Token);
            RNSAPI.User(new User(decoded.ShortHandSymbol, decoded.Role));
        }
    }

    public static RoutingTable = {
        generateLink: function (route: string) {
            return vm.router.link(route);
        },
        showCaseView: function (params?: any) {
            if (params) vm.router.navigate(`/case/${encodeURIComponent(params.caseId)}`);
            else vm.router.navigate("/case");
        },
        showCaseOverview: function () { vm.router.navigate("/cases") },
        showCaseEntriesView: function (params: any) {
            if (params.eCaseRecordId) vm.router.navigate(`/caseentries/${encodeURIComponent(params.caseId)}/${encodeURIComponent(params.eCaseRecordId)}`)
            else vm.router.navigate(`/caseentries/${encodeURIComponent(params.caseId)}`)
        },
        showCaseEntryView: function (params: any) {
            if (params.eCaseRecordId) vm.router.navigate(`/caseentry/${encodeURIComponent(params.caseId)}/${encodeURIComponent(params.eCaseRecordId)}`)
            else vm.router.navigate(`/caseentry/${encodeURIComponent(params.caseId)}`)
        },
        showTagOverview: function () { vm.router.navigate("/tags"); },
        showTagView: function (params?: any) {
            if (params && params.name) vm.router.navigate(`/tag/${encodeURIComponent(params.name)}`);
            else vm.router.navigate("/tag");
        },
        showViewOverview: function () { vm.router.navigate("/views"); },
        showViewView: function (params?: any) {
            if (params && params.name) vm.router.navigate(`/view/${encodeURIComponent(params.name)}`);
            else vm.router.navigate("/view");
        },
        showTreeOverview: function () { vm.router.navigate("/trees"); },
        showTreeView: function (params?: any) {
            if (params && params.id && params.type) vm.router.navigate(`/tree/${encodeURIComponent(params.type)}/${encodeURIComponent(params.id)}`);
            else vm.router.navigate("/tree");
        },
        showStrategyOverview: function () { vm.router.navigate("/strategies"); },
        showStrategyView: function () { vm.router.navigate("/strategy"); },
        showTaxonomieOverview: function () { vm.router.navigate("/taxonomies"); },
        showTaxonomieView: function (params?: any) {
            if (params && params.id) vm.router.navigate(`/taxonomie/${encodeURIComponent(params.id)}`);
            else vm.router.navigate("/taxonomie");
        },
        showDashboardView: function (params?: any, ignore = false) {
            if (ignore) MainViewModel.paused = true;
            if (params) {
                vm.router.navigate(`/dashboard/${params.view}`);
            }
            else vm.router.navigate("/dashboard");
        },
        showAppointmentView: function (params?: any) {
            if (params) {
                if (params.id) {
                    vm.router.navigate(`/appointment/${params.id}`);
                } else if (params.startdate) {
                    vm.router.navigate(`/appointment?startdate=${encodeURIComponent(params.startdate)}`);
                }
            }
            else vm.router.navigate("/appointment");
        },
        showDeadlineView: function (params?: any) {
            if (params) vm.router.navigate(`/deadline/${params.id}`);
            else vm.router.navigate("/deadline");
        },
        showDeadlineOverview: function () { vm.router.navigate("/deadlines") },
        showResubmissionOverview: function () { vm.router.navigate("/resubmissions"); },
        showResubmissionView: function (params?: any) {
            if (params && params.caseId) vm.router.navigate(`/resubmission?caseId=${encodeURIComponent(params.caseId)}`);
            else if (params) vm.router.navigate(`/resubmission/${params.id}`);
            else vm.router.navigate("/resubmission");
        },
        showAddressView: function (params?: any) {
            if (params) vm.router.navigate(`/address/${params.type}/${encodeURIComponent(params.keyword)}`);
            else vm.router.navigate("/address");
        },
        showAddressOverview: function () { vm.router.navigate("/addresses"); },
        showTextTemplateView: function (params?: any) { vm.router.navigate(`/generation/${encodeURIComponent(params.caseId)}`); },
        showNoteView: function (params?: any) {
            if (params) vm.router.navigate(`/note/${encodeURIComponent(params.id)}`);
            else vm.router.navigate("/note");
        },
        showMailView: function (params: any) {
            vm.router.navigate(`/mail/${encodeURIComponent(params.accountId)}/${encodeURIComponent(params.mailId)}`);
        },
        showInboxView: function (params: any) {
            if (params) vm.router.navigate(`/inbox/${encodeURIComponent(params.id)}`);
            else vm.router.navigate(`/inbox/`);
        },
        showComposeView: function (params: any) {
            if (params && params.caseId && params.eCaseRecordId) vm.router.navigate(`/compose/${encodeURIComponent(params.caseId)}/${encodeURIComponent(params.eCaseRecordId)}`);
            else if (params && params.caseId) vm.router.navigate(`/compose/${encodeURIComponent(params.caseId)}`);
            else vm.router.navigate(`/compose`);
        },
        showInboxOverview: () => vm.router.navigate(`/inboxes/`),
        showZPE: () => vm.router.navigate(`/zpe`),
        showDictation: function (params?: any) {
            if (params && params.id) vm.router.navigate(`/dictation/${encodeURIComponent(params.id)}`);
            else vm.router.navigate(`/dictation/`);
        },
        showCalculatorView: function () { vm.router.navigate("/calculator"); },
        showLoginView: function () {
            if (window.location.hostname === 'localhost' || window.location.hostname === 'dev.olyro.de' || window.location.hostname === 'dev.intelli4pro.de') {
                window.location.href = "./#/login";
            } else {
                window.location.href = "./login";
            }
        },
        showWorkflowView: (wfk: string) => vm.router.navigate(`/wfk/${wfk}`),
        showDebugView: function () { vm.currentRoute("debug-view"); },
        showExtendedMainView: function (params?: any) {
            if (params) {
                vm.router.navigate(`/extended-main/${encodeURIComponent(params.caseId)}`);
            }
            else vm.router.navigate("/dashboard");
        },
        showUnitAdd: () => vm.router.navigate(`/unit/add`),
        setOrigin: function (origin: string) { RNSAPI.origin = origin; }
    }
}

let vm = new MainViewModel();

ko.applyBindings(vm);

module.exports = MainViewModel.RoutingTable;
